<div class="card flex flex-wrap gap-3">

  <div class="p-2 border-1 surface-border border-round">

    <div class="flex">
      <h3>Datos de panel</h3>
    </div>

    <form [formGroup]="form">

      <div class="flex">

        <div class="form-column">
          <label for="txtTitle">{{ "TITLE" | translate | requiredLabel }}</label>
          <input type="text" id="txtTitle" pInputText formControlName="title" />
        </div>

        <div class="form-column">
          <label for="txtAllowedProfiles">Perfiles permitidos</label>
          <input type="text" id="txtAllowedProfiles" pInputText formControlName="allowedProfiles" />
        </div>

        <p-button label="Editar" icon="pi pi-pencil" (click)="editProperties()"></p-button>

      </div>


    </form>

  </div>

</div>

<div class="card flex flex-wrap gap-3">

  <div class="p-2 border-1 surface-border border-round w-30rem">
    <p>Informes disponibles</p>
    <ul class="list-none flex flex-column gap-2 p-0 m-0">
      <li class="p-2 border-round shadow-1" *ngFor="let report of availableReports" pDraggable
        (onDragStart)="dragStart(report)" (onDragEnd)="dragEnd()">
        <span class="text-overflow-clip mr-1">{{report.title}}</span>
        <span class="text-blue-500">{{ report.width }}{{report.widthUnit }}x{{report.height}}{{report.heightUnit}}</span>
      </li>
    </ul>
  </div>

  <div class="p-2 border-1 surface-border border-round w-30rem" pDroppable (onDrop)="drop()">
    <p>Informes del panel</p>
    <ul class="list-none flex flex-column gap-2 p-0 m-0" *ngIf="selectedReports">
      <li class="p-2 border-round shadow-1 flex flex-row justify-content-between align-items-center"
        *ngFor="let report of selectedReports">
        <div>
          <span class="text-overflow-clip mr-1">{{report.title}}</span>
          <span class="text-blue-500">{{ report.width }}{{report.widthUnit }}x{{report.height}}{{report.heightUnit}}</span>
        </div>
        <p-button icon="pi pi-times" size="small" [rounded]="true" [text]="true" severity="danger"
          (click)="deleteReport(report)"></p-button>
      </li>
    </ul>
  </div>

</div>
